<template>
    <div class="opt-overview-bar-wrapper">
        <div class="options-sel">
            <div>
                <span class="channel-search">{{ quesChannel }} :</span>
                <ChannelSelect value="all" @change="channelSelect" />
            </div>
            <div>{{ language }} : <LangSelect value="all" class="lang-select" @change="langSelect" :requireAll="true"></LangSelect></div>
        </div>
    </div>
</template>

<script>
import ChannelSelect from "@/views/zhiji/components/channelSelect/index";
import LangSelect from "@/components/langSelect";

export default {
    name: "OptOverviewBar",
    components: {
        ChannelSelect,
        LangSelect
    },
    data() {
        return {
            curDates: null
        };
    },
    mounted() {
        this.curDates = this.getCurrentDates();
        this.$emit("timeChange", this.zhiji.dateFormat(this.curDates, "YYYY/MM/DD"));
    },
    computed: {
        quesChannel() {
            return this.$t("zhiji.overview.quesChannel");
        },
        language() {
            return this.$t("zhiji.common.language");
        }
    },
    methods: {
        langSelect(data) {
            this.$emit("langSelect", {
                value: data
            });
        },
        channelSelect(data) {
            this.$emit("channelSelect", {
                value: data
            });
        },
        getCurrentDates() {
            return new Date(Date.now());
        }
    }
};
</script>

<style lang="scss" scoped>
.opt-overview-bar-wrapper {
    height: 67px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;

    div {
        margin-right: 20px;
        display: flex;
        align-items: center;

        .select {
            width: 120px;
            margin-left: 10px;
        }
    }
    .channel-search {
        width: 66px;
    }

    .lang-select {
        margin-left: 12px;
        width: 120px;
    }
}
</style>
